<script setup lang="ts">
import PasswordChangeFormCard from "@/app/components/settings/PasswordChangeFormCard.vue";
import { useExpertProfile } from "@/app/composables/useExpertProfile";

const { changePassword } = useExpertProfile();
</script>

<template>
    <PasswordChangeFormCard :change-password="changePassword" />
</template>
